import { Route, Routes, useLocation } from "react-router-dom";
import ReactPixel from "react-facebook-pixel";
import "bootstrap/dist/css/bootstrap.min.css";

import "bootstrap-icons/font/bootstrap-icons.css";

// slider css
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";


import UserLayout from "./User/UserLayout";
import Home from "./User/Home";

import ProductDetails from './User/ProductDetails';
import BlogDetails from './User/BlogDetails';
import AffiliateProgram from './User/AffiliateProgram';
import ContactUs from './User/ContactUs';
import ShippingPolicy from './User/ShippingPolicy';
import ReturnsAndExchangePolicy from './User/ReturnsAndExchangePolicy';
import RefundPolicy from './User/RefundPolicy';
import Checkout from "./User/Checkout";

import AdminLayout from "./Admin/Layout";
// import AdminDashboard from "./Admin/Dashboard";
// import AdminBanners from "./Admin/Banners/Banners";
// import AdminBanners50 from "./Admin/Banners50/Banners";
// import AdminProducts from "./Admin/Products/Products";
// import AdminTestimonials from "./Admin/Testimonials/Testimonials";
// import AdminBlogs from "./Admin/Blogs/Blogs";
// import AdminAffiliatesTmp from "./Admin/AdminAffiliates/AdminAffiliatesTmp"; // un
// import AdminOrders from "./Admin/Orders";
// import AdminHistory from "./Admin/History";

// import DistributorDashboard from "./Distributor/Dashboard/Dashboard";
// import DistributorSaleHistory from "./Distributor/SaleHistory/SaleHistory";
// import DistributorTeams from "./Distributor/Teams/Teams";

import Page404 from "./components/Page404";
import Login from "./components/Login";
import ResetPassword from "./components/ResetPassword";

import { ToastContainer } from "react-toastify";
import { useEffect } from "react";

import { getAnonUserId } from "./helpers/utils";

import PrivateRoute from "./PrivateRoutes/PrivateRoute";
import { routesConfig } from "./PrivateRoutes/routesConfig";

export default function App() {
  // PixelTracker initializes Meta Pixel and fires pageviews on route change
  function PixelTracker() {
    const location = useLocation();

    useEffect(() => {
      const advancedMatching = {};
      const options = { autoConfig: true, debug: false };
      const pixelId = process.env.REACT_APP_PIXEL_ID || null;

      // debug: show what pixel id we will initialize with
      console.debug("PixelTracker: REACT_APP_PIXEL_ID=", process.env.REACT_APP_PIXEL_ID, "resolved pixelId=", pixelId);

      if (!pixelId) {
        console.warn("PixelTracker: pixel id is missing — skipping Pixel init.");
        return;
      }

      try {
        ReactPixel.init(pixelId, advancedMatching, options);
      } catch (e) {
        console.warn("ReactPixel init failed:", e);
      }
    }, []);

    useEffect(() => {
      try {
        ReactPixel.pageView();
      } catch (e) {}
    }, [location]);

    return null;
  }

  useEffect(() => {
    getAnonUserId();
  }, []);

  return (
    <>
      <PixelTracker />
      <Routes>
        {/* auth routes */}
        <Route path="/login" element={<Login />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />

        {/* admin routes allowedRoles={["admin"]}*/}
        <Route element={<AdminLayout />}>
          {routesConfig.map(({ path, element, roles }) => (
            <Route
              key={path}
              path={path}
              element={
                <PrivateRoute allowedRoles={roles}>{element}</PrivateRoute>
              }
            />
          ))}
        </Route>
        {/* user routes */}
        <Route element={<UserLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/:product_name" element={<ProductDetails />} />
          <Route path="/blog-detail/:blog_id" element={<BlogDetails />} />
          <Route path="/affiliate-program" element={<AffiliateProgram />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />
          <Route path="/shipping-policy" element={<ShippingPolicy />} />
          <Route path="/returns-and-exchange-policy" element={<ReturnsAndExchangePolicy />} />
        </Route>

        <Route path="/checkout" element={<Checkout />} />
        {/* <Route path="/tmpuser" element={<AdminAffiliatesTmp />} /> */}

        {/* misc */}
        <Route path="/unauthorized" element={<Page404 />} />
        <Route path="*" element={<Page404 />} />
      </Routes>
      <ToastContainer position="bottom-left" theme="colored" />
    </>
  );
}

//           <Route element={<AdminLayout />}>
//           <Route path="/dashboard" element={<AdminDashboard />} />
//           <Route path="/banners" element={<AdminBanners />} />
//           <Route path="/banners50" element={<AdminBanners50 />} />
//           <Route path="/products" element={<AdminProducts />} />
//           <Route path="/testimonials" element={<AdminTestimonials />} />
//           <Route path="/blogs" element={<AdminBlogs />} />
//           <Route path="/affiliates" element={<AdminAffiliates />} />
//           <Route path="/orders" element={<AdminOrders />} />
//           <Route path="/history" element={<AdminHistory />} />

//           {/* distributor */}
//           <Route path="/dist/dashboard" element={<DistributorDashboard />} />
//           <Route path="/sale-history" element={<DistributorSaleHistory />} />
//           <Route path="/teams" element={<DistributorTeams />} />
//         </Route>
